import * as api from 'api';
import { actionTypes } from 'redux-resource';

export const fetchAllDevices = () => (dispatch) => {
  const actionDefaults = {
    resourceType: 'devices',
    requestKey: 'all',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchAllDevices()
    .then((response) => {
      const resources = response.map((device) => ({
        ...device,
        id: device.sku,
      }));

      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const findDevice = (sku) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'devices',
    requestKey: 'find',
    resources: [sku],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .findDevice(sku)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: [{ id: sku, ...response.data }],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
        statusCode: err.response && err.response.status,
      });
    });
};
